import ReviewCard from "./review-card";

export { ReviewCard };
